import React from 'react'
import {Card, Button, Nav} from 'react-bootstrap';
import '../mysass.scss';

const Workouts = () => {
  return (

    <>

    <Card className="bg-dark text-white" >
      <Card.Img src="biceps.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>BICEPS</Card.Title>
        <Card.Text>
        Click here for more biceps videos: <Button variant="outline-light"><Nav.Link href="/biceps">Go Train Biceps</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>
    {/* <br/> */}
    <Card className="bg-dark text-white" >
      <Card.Img src="triceps.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>TRICEPS</Card.Title>
        <Card.Text>
        Click here for more triceps videos: <Button variant="outline-light"><Nav.Link href='/triceps'>Go Train Triceps</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>
    {/* <br/> */}
    <Card className="bg-light text-dark" >
      <Card.Img src="abs.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>ABS</Card.Title>
        <Card.Text>
        Click here for more abs videos: <Button variant="outline-dark"><Nav.Link href='/abs'>Go Train ABS</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>
    {/* <br/> */}
    <Card className="bg-dark text-white" >
      <Card.Img src="chest.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>CHEST</Card.Title>
        <Card.Text>
        Click here for more chest videos: <Button variant="outline-light"><Nav.Link href='/chest'>Go Train Chest</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>

    <Card className="bg-dark text-dark" >
      <Card.Img src="shoulder.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>BACK</Card.Title>
        <Card.Text>
        Click here for more back videos: <Button variant="outline-dark"><Nav.Link href='/back'>Go Train Back</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>

    <Card className="bg-dark text-white" >
      <Card.Img src="leg.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>LEG</Card.Title>
        <Card.Text>
        Click here for more leg videos: <Button variant="outline-dark"><Nav.Link href='/leg'>Go Train Leg</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>

    <Card className="bg-dark text-white" >
      <Card.Img src="cardio.jpg" alt="Card image" style={{height:'400px', objectFit:'cover'}} />
      <Card.ImgOverlay>
        <Card.Title style={{fontSize:'25px'}}>CARDIO</Card.Title>
        <Card.Text>
        Click here for more cardio videos: <Button variant="outline-light"><Nav.Link href='/cardio'>Go Train Cardio</Nav.Link></Button>
        </Card.Text>
      </Card.ImgOverlay>
    </Card>

    </>
    
  )
}

export default Workouts